import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "lib/apiInstance";
// Custom base query with error handling
import { LOCAL_STORAGE } from "utils/constant";
import { BASE_URL, EndpointsSlug } from "./endpoints";

export const authService = createApi({
  reducerPath: "authService",
  baseQuery: baseQueryWithReauth({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem(LOCAL_STORAGE.USER_TOKEN) || "";
      headers.set("Content-type", "application/json; charset=UTF-8");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    loginWithGoogle: builder.mutation({
      query: (credential) => ({
        url: EndpointsSlug.LOGIN_WITH_GOOGLE,
        method: "POST",
        body: { access_token: credential },
      }),
    }),
    getUsersList: builder.query({
      query: (params) => ({
        url: EndpointsSlug.GET_ALL_USERS,
        method: "GET",
        params,
      }),
    }),
    getCreatorsList: builder.query({
      query: (params) => ({
        url: EndpointsSlug.GET_ALL_CREATORS,
        method: "GET",
        params,
      }),
    }),
    addCoinsToUser: builder.mutation({
      query: ({ userId, coinsToAdd }) => ({
        url: `/${SERVICE_NAME.ADMIN}/user/${userId}/add-coins`,
        method: "POST",
        body: { coinsToAdd },
      }),
    }),
  }),
});

export const {
  useLoginWithGoogleMutation,
  useGetUsersListQuery,
  useGetCreatorsListQuery,
  useAddCoinsToUserMutation,
} = authService;
export default authService;
